import './skeleton.css'
const GeneralStatsItemSkeleton = props => {


    return (
        <tr className="skeleton-row">
            {[...Array(6)].map((_, index) => (
                <td key={index}>
                    <div className="skeleton-cell"></div>
                </td>
            ))}
        </tr>


    )

}

export default GeneralStatsItemSkeleton
